function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Green-Version",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "04_Dashboard_Green",
  transform: "translate(-235.000000, -201.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Card",
  transform: "translate(235.000000, 201.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-6-Copy-2",
  fill: "#FFFFFF",
  stroke: "#F3F5FA",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("circle", {
  id: "Oval-Copy-2",
  cx: 20,
  cy: 20,
  r: 19
})), /*#__PURE__*/React.createElement("g", {
  id: "credit-card",
  transform: "translate(12.000000, 14.000000)",
  stroke: "#000000",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  x: 0,
  y: 0,
  width: 15.7142857,
  height: 11.4285714,
  rx: 1.42857143
}), /*#__PURE__*/React.createElement("line", {
  x1: 2.85714286,
  y1: 4.28571429,
  x2: 7.85714286,
  y2: 4.28571429,
  id: "Path"
}), /*#__PURE__*/React.createElement("line", {
  x1: 2.85714286,
  y1: 6.42857143,
  x2: 9.28571429,
  y2: 6.42857143,
  id: "Path"
}), /*#__PURE__*/React.createElement("line", {
  x1: 2.85714286,
  y1: 8.57142857,
  x2: 10.7142857,
  y2: 8.57142857,
  id: "Path"
})))));

function SvgCard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "F2DF1587-847A-40F4-B53A-C8A6FD6082BA") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard);
export default __webpack_public_path__ + "static/media/Card.0ae2f71c.svg";
export { ForwardRef as ReactComponent };